//POS SYSTEM Reducer

import {
  GET_POS_SYSTEM_RENDER_DATA,
  GET_POS_SYSTEM_RENDER_DATA_SUCCESS,
  GET_POS_SYSTEM_RENDER_DATA_FAILURE,
  GET_POS_SYSTEM_LIST,
  GET_POS_SYSTEM_LIST_SUCCESS,
  GET_POS_SYSTEM_LIST_FAILURE,
  GET_POS_SYSTEM_DATA,
  GET_POS_SYSTEM_DATA_SUCCESS,
  GET_POS_SYSTEM_DATA_FAILURE,
  CREATE_POS_SYSTEM,
  CREATE_POS_SYSTEM_SUCCESS,
  CREATE_POS_SYSTEM_FAILURE,
  UPDATE_POS_SYSTEM,
  UPDATE_POS_SYSTEM_SUCCESS,
  UPDATE_POS_SYSTEM_FAILURE,
  DELETE_POS_SYSTEM,
  DELETE_POS_SYSTEM_SUCCESS,
  DELETE_POS_SYSTEM_FAILURE,
  GET_POS_SYSTEM_TO_USER_LIST,
  GET_POS_SYSTEM_TO_USER_LIST_SUCCESS,
  GET_POS_SYSTEM_TO_USER_LIST_FAILURE,
  GET_POS_SYSTEM_TO_USER_DATA,
  GET_POS_SYSTEM_TO_USER_DATA_SUCCESS,
  GET_POS_SYSTEM_TO_USER_DATA_FAILURE,
  CREATE_POS_SYSTEM_TO_USER,
  CREATE_POS_SYSTEM_TO_USER_SUCCESS,
  CREATE_POS_SYSTEM_TO_USER_FAILURE,
  UPDATE_POS_SYSTEM_TO_USER,
  UPDATE_POS_SYSTEM_TO_USER_SUCCESS,
  UPDATE_POS_SYSTEM_TO_USER_FAILURE,
  DELETE_POS_SYSTEM_TO_USER,
  DELETE_POS_SYSTEM_TO_USER_SUCCESS,
  DELETE_POS_SYSTEM_TO_USER_FAILURE,
  GET_POS_ORDER_LIST,
  GET_POS_ORDER_LIST_SUCCESS,
  GET_POS_ORDER_LIST_FAILURE,
  POS_ORDER_SEARCH,
  POS_ORDER_SEARCH_SUCCESS,
  POS_ORDER_SEARCH_FAILURE,
  GET_POS_ORDER_DATA,
  GET_POS_ORDER_DATA_SUCCESS,
  GET_POS_ORDER_DATA_FAILURE,
  CREATE_POS_ORDER,
  CREATE_POS_ORDER_SUCCESS,
  CREATE_POS_ORDER_FAILURE,
  UPDATE_POS_ORDER,
  UPDATE_POS_ORDER_SUCCESS,
  UPDATE_POS_ORDER_FAILURE,
  DELETE_POS_ORDER,
  DELETE_POS_ORDER_SUCCESS,
  DELETE_POS_ORDER_FAILURE,
  CREATE_POS_ORDER_PAYMENT_REQUEST,
  CREATE_POS_ORDER_PAYMENT_REQUEST_SUCCESS,
  CREATE_POS_ORDER_PAYMENT_REQUEST_FAILURE,
  CREATE_POS_ORDER_TENDER,
  CREATE_POS_ORDER_TENDER_SUCCESS,
  CREATE_POS_ORDER_TENDER_FAILURE,
  INTERNAL_TERMINAL_PAYMENT_RESULT,
  INTERNAL_TERMINAL_PAYMENT_RESULT_SUCCESS,
  INTERNAL_TERMINAL_PAYMENT_RESULT_FAILURE,
  INTERNAL_POS_SYSTEM_TICKETS_UPDATE,
  INTERNAL_POS_SYSTEM_TICKETS_UPDATE_SUCCESS,
  INTERNAL_POS_SYSTEM_TICKETS_UPDATE_FAILURE,
  GET_POS_SYSTEM_OVERVIEW,
  GET_POS_SYSTEM_OVERVIEW_SUCCESS,
  GET_POS_SYSTEM_OVERVIEW_FAILURE,
  VOID_POS_ORDER_PAYMENT_REQUEST,
  VOID_POS_ORDER_PAYMENT_REQUEST_SUCCESS,
  VOID_POS_ORDER_PAYMENT_REQUEST_FAILURE,
  PRINT_POS_ORDER_RECEIPT,
  PRINT_POS_ORDER_RECEIPT_SUCCESS,
  PRINT_POS_ORDER_RECEIPT_FAILURE,
  EMAIL_POS_ORDER_RECEIPT,
  EMAIL_POS_ORDER_RECEIPT_SUCCESS,
  EMAIL_POS_ORDER_RECEIPT_FAILURE,
  REFUND_POS_ORDER,
  REFUND_POS_ORDER_SUCCESS,
  REFUND_POS_ORDER_FAILURE,
} from "./actionType";

const initialState = {
  // --- POS SYSTEM RENDER DATA ---
  renderData: [],
  loadingRenderData: false,
  errorRenderData: null,

  // --- POS SYSTEM LIST ---
  posSystemList: [],
  loadingPosSystemList: false,
  errorPosSystemList: null,

  // --- POS SYSTEM DATA ---
  posSystemData: {},
  loadingPosSystemData: false,
  errorPosSystemData: null,

  // --- POS SYSTEM CRUD ---
  loadingCreatePosSystem: false,
  successCreatePosSystem: false,
  errorCreatePosSystem: null,

  loadingUpdatePosSystem: false,
  successUpdatePosSystem: [],
  errorUpdatePosSystem: [],

  loadingDeletePosSystem: false,
  successDeletePosSystem: false,
  errorDeletePosSystem: null,

  // --- POS SYSTEM TO USER LIST ---
  posSystemToUserList: [],
  loadingPosSystemToUserList: false,
  errorPosSystemToUserList: null,

  // --- POS SYSTEM TO USER DATA ---
  posSystemToUserData: {},
  loadingPosSystemToUserData: false,
  errorPosSystemToUserData: null,

  // --- POS SYSTEM TO USER CRUD ---
  loadingCreatePosSystemToUser: false,
  successCreatePosSystemToUser: [],
  errorCreatePosSystemToUser: null,

  loadingUpdatePosSystemToUser: false,
  successUpdatePosSystemToUser: [],
  errorUpdatePosSystemToUser: null,

  loadingDeletePosSystemToUser: false,
  successDeletePosSystemToUser: false,
  errorDeletePosSystemToUser: null,
  // --- POS ORDER LIST ---
  posOrderList: [],
  loadingPosOrderList: false,
  errorPosOrderList: null,

  // --- POS ORDER SEARCH ---
  posOrderSearch: [],
  loadingPosOrderSearch: false,
  errorPosOrderSearch: null,

  // --- POS ORDER DATA ---
  posOrderData: {},
  loadingPosOrderData: false,
  errorPosOrderData: null,

  // --- POS ORDER CRUD ---
  loadingCreatePosOrder: false,
  successCreatePosOrder: false,
  errorCreatePosOrder: null,

  loadingUpdatePosOrder: false,
  successUpdatePosOrder: [],
  errorUpdatePosOrder: null,

  loadingDeletePosOrder: false,
  successDeletePosOrder: [],
  errorDeletePosOrder: null,

  // --- POS ORDER PAYMENT REQUEST ---
  loadingCreatePosOrderPaymentRequest: false,
  successCreatePosOrderPaymentRequest: [],
  errorCreatePosOrderPaymentRequest: [],
  loadingCreatePosOrderTender: false,
  successCreatePosOrderTender: [],
  errorCreatePosOrderTender: [],

  loadingInternalTerminalPaymentResult: false,
  successInternalTerminalPaymentResult: [],
  errorInternalTerminalPaymentResult: [],

  loadingInternalPosSystemTicketsUpdate: false,
  successInternalPosSystemTicketsUpdate: [],
  errorInternalPosSystemTicketsUpdate: [],

  //GET_POS_SYSTEM_OVERVIEW
  posSystemOverview: [],
  loadingPosSystemOverview: false,
  errorPosSystemOverview: null,

  loadingVoidPosOrderPaymentRequest: false,
  successVoidPosOrderPaymentRequest: [],
  errorVoidPosOrderPaymentRequest: [],

  //PRINT_POS_ORDER_RECEIPT
  loadingPrintPosOrderReceipt: false,
  successPrintPosOrderReceipt: [],
  errorPrintPosOrderReceipt: [],

  //EMAIL_POS_ORDER_RECEIPT
  loadingEmailPosOrderReceipt: false,
  successEmailPosOrderReceipt: [],
  errorEmailPosOrderReceipt: [],

  //REFUND_POS_ORDER
  loadingRefundPosOrder: false,
  successRefundPosOrder: [],
  errorRefundPosOrder: [],
};

const posSystemReducer = (state = initialState, action) => {
  switch (action.type) {
    // ==========================================
    // POS SYSTEM RENDER DATA
    // ==========================================
    case GET_POS_SYSTEM_RENDER_DATA:
      return { ...state, loadingRenderData: true, errorRenderData: null };
    case GET_POS_SYSTEM_RENDER_DATA_SUCCESS:
      return { ...state, loadingRenderData: false, renderData: action.payload };
    case GET_POS_SYSTEM_RENDER_DATA_FAILURE:
      return {
        ...state,
        loadingRenderData: false,
        errorRenderData: action.payload,
      };

    // ==========================================
    // POS SYSTEM LIST
    // ==========================================
    case GET_POS_SYSTEM_LIST:
      return { ...state, loadingPosSystemList: true, errorPosSystemList: null };
    case GET_POS_SYSTEM_LIST_SUCCESS:
      return {
        ...state,
        loadingPosSystemList: false,
        posSystemList: action.payload,
      };
    case GET_POS_SYSTEM_LIST_FAILURE:
      return {
        ...state,
        loadingPosSystemList: false,
        errorPosSystemList: action.payload,
      };

    // ==========================================
    // POS SYSTEM DATA
    // ==========================================
    case GET_POS_SYSTEM_DATA:
      return { ...state, loadingPosSystemData: true, errorPosSystemData: null };
    case GET_POS_SYSTEM_DATA_SUCCESS:
      return {
        ...state,
        loadingPosSystemData: false,
        posSystemData: action.payload,
      };
    case GET_POS_SYSTEM_DATA_FAILURE:
      return {
        ...state,
        loadingPosSystemData: false,
        errorPosSystemData: action.payload,
      };

    // ==========================================
    // CREATE POS SYSTEM
    // ==========================================
    case CREATE_POS_SYSTEM:
      return {
        ...state,
        loadingCreatePosSystem: true,
        successCreatePosSystem: false,
        errorCreatePosSystem: null,
      };
    case CREATE_POS_SYSTEM_SUCCESS:
      return {
        ...state,
        loadingCreatePosSystem: false,
        successCreatePosSystem: true,
      };
    case CREATE_POS_SYSTEM_FAILURE:
      return {
        ...state,
        loadingCreatePosSystem: false,
        successCreatePosSystem: false,
        errorCreatePosSystem: action.payload,
      };

    // ==========================================
    // UPDATE POS SYSTEM
    // ==========================================
    case UPDATE_POS_SYSTEM:
      return {
        ...state,
        loadingUpdatePosSystem: true,

      };
    case UPDATE_POS_SYSTEM_SUCCESS:
      return {
        ...state,
        loadingUpdatePosSystem: false,
        successUpdatePosSystem: action.payload,
      };
    case UPDATE_POS_SYSTEM_FAILURE:
      return {
        ...state,
        loadingUpdatePosSystem: false,
        successUpdatePosSystem: action.payload,
        errorUpdatePosSystem: action.payload,
      };

    // ==========================================
    // DELETE POS SYSTEM
    // ==========================================
    case DELETE_POS_SYSTEM:
      return {
        ...state,
        loadingDeletePosSystem: true,
        successDeletePosSystem: false,
        errorDeletePosSystem: null,
      };
    case DELETE_POS_SYSTEM_SUCCESS:
      return {
        ...state,
        loadingDeletePosSystem: false,
        successDeletePosSystem: true,
      };
    case DELETE_POS_SYSTEM_FAILURE:
      return {
        ...state,
        loadingDeletePosSystem: false,
        successDeletePosSystem: false,
        errorDeletePosSystem: action.payload,
      };

    // ==========================================
    // POS SYSTEM TO USER LIST
    // ==========================================
    case GET_POS_SYSTEM_TO_USER_LIST:
      return {
        ...state,
        loadingPosSystemToUserList: true,
        errorPosSystemToUserList: null,
      };
    case GET_POS_SYSTEM_TO_USER_LIST_SUCCESS:
      return {
        ...state,
        loadingPosSystemToUserList: false,
        posSystemToUserList: action.payload,
      };
    case GET_POS_SYSTEM_TO_USER_LIST_FAILURE:
      return {
        ...state,
        loadingPosSystemToUserList: false,
        errorPosSystemToUserList: action.payload,
      };

    // ==========================================
    // POS SYSTEM TO USER DATA
    // ==========================================
    case GET_POS_SYSTEM_TO_USER_DATA:
      return {
        ...state,
        loadingPosSystemToUserData: true,
        errorPosSystemToUserData: null,
      };
    case GET_POS_SYSTEM_TO_USER_DATA_SUCCESS:
      return {
        ...state,
        loadingPosSystemToUserData: false,
        posSystemToUserData: action.payload,
      };
    case GET_POS_SYSTEM_TO_USER_DATA_FAILURE:
      return {
        ...state,
        loadingPosSystemToUserData: false,
        errorPosSystemToUserData: action.payload,
      };

    // ==========================================
    // CREATE POS SYSTEM TO USER
    // ==========================================
    case CREATE_POS_SYSTEM_TO_USER:
      return {
        ...state,
        loadingCreatePosSystemToUser: true,
      };

    // ==========================================
    // POS ORDER LIST
    // ==========================================
    case GET_POS_ORDER_LIST:
      return {
        ...state,
        loadingPosOrderList: true,
        errorPosOrderList: null,
      };
    case GET_POS_ORDER_LIST_SUCCESS:
      return {
        ...state,
        loadingPosOrderList: false,
        posOrderList: action.payload,
      };
    case GET_POS_ORDER_LIST_FAILURE:
      return {
        ...state,
        loadingPosOrderList: false,
        errorPosOrderList: action.payload,
      };

    // ==========================================
    // POS ORDER SEARCH
    // ==========================================
    case POS_ORDER_SEARCH:
      return {
        ...state,
        loadingPosOrderSearch: true,
        errorPosOrderSearch: null,
      };
    case POS_ORDER_SEARCH_SUCCESS:
      return {
        ...state,
        loadingPosOrderSearch: false,
        posOrderSearch: action.payload,
      };
    case POS_ORDER_SEARCH_FAILURE:
      return {
        ...state,
        loadingPosOrderSearch: false,
        errorPosOrderSearch: action.payload,
      };

    // ==========================================
    // POS ORDER DATA
    // ==========================================
    case GET_POS_ORDER_DATA:
      return {
        ...state,
        loadingPosOrderData: true,
        errorPosOrderData: null,
      };
    case GET_POS_ORDER_DATA_SUCCESS:
      return {
        ...state,
        loadingPosOrderData: false,
        posOrderData: action.payload,
      };
    case GET_POS_ORDER_DATA_FAILURE:
      return {
        ...state,
        loadingPosOrderData: false,
        errorPosOrderData: action.payload,
      };

    // ==========================================
    // CREATE POS ORDER
    // ==========================================
    case CREATE_POS_ORDER:
      return {
        ...state,
        loadingCreatePosOrder: true,
      };
    case CREATE_POS_ORDER_SUCCESS:
      return {
        ...state,
        loadingCreatePosOrder: false,
        successCreatePosOrder: action.payload,
      };
    case CREATE_POS_ORDER_FAILURE:
      return {
        ...state,
        loadingCreatePosOrder: false,
        successCreatePosOrder: action.payload,
        errorCreatePosOrder: action.payload,
      };

    // ==========================================
    // UPDATE POS ORDER
    // ==========================================
    case UPDATE_POS_ORDER:
      return {
        ...state,
        loadingUpdatePosOrder: true,
      };
    case UPDATE_POS_ORDER_SUCCESS:
      return {
        ...state,
        loadingUpdatePosOrder: false,
        successUpdatePosOrder: action.payload,
      };
    case UPDATE_POS_ORDER_FAILURE:
      return {
        ...state,
        loadingUpdatePosOrder: false,
        successUpdatePosOrder: action.payload,
        errorUpdatePosOrder: action.payload,
      };

    // ==========================================
    // DELETE POS ORDER
    // ==========================================
    case DELETE_POS_ORDER:
      return {
        ...state,
        loadingDeletePosOrder: true,
      };
    case DELETE_POS_ORDER_SUCCESS:
      return {
        ...state,
        loadingDeletePosOrder: false,
        successDeletePosOrder: action.payload,
      };
    case DELETE_POS_ORDER_FAILURE:
      return {
        ...state,
        loadingDeletePosOrder: false,
        successDeletePosOrder: action.payload,
        errorDeletePosOrder: action.payload,
      };
    case CREATE_POS_SYSTEM_TO_USER_SUCCESS:
      return {
        ...state,
        loadingCreatePosSystemToUser: false,
        successCreatePosSystemToUser: action.payload,
      };
    case CREATE_POS_SYSTEM_TO_USER_FAILURE:
      return {
        ...state,
        loadingCreatePosSystemToUser: false,
        successCreatePosSystemToUser: action.payload,
        errorCreatePosSystemToUser: action.payload,
      };

    // ==========================================
    // UPDATE POS SYSTEM TO USER
    // ==========================================
    case UPDATE_POS_SYSTEM_TO_USER:
      return {
        ...state,
        loadingUpdatePosSystemToUser: true,
      };
    case UPDATE_POS_SYSTEM_TO_USER_SUCCESS:
      return {
        ...state,
        loadingUpdatePosSystemToUser: action.payload,
        successUpdatePosSystemToUser: action.payload,
      };
    case UPDATE_POS_SYSTEM_TO_USER_FAILURE:
      return {
        ...state,
        loadingUpdatePosSystemToUser: false,
        successUpdatePosSystemToUser: action.payload,
        errorUpdatePosSystemToUser: action.payload,
      };

    // ==========================================
    // DELETE POS SYSTEM TO USER
    // ==========================================
    case DELETE_POS_SYSTEM_TO_USER:
      return {
        ...state,
        loadingDeletePosSystemToUser: true,
        successDeletePosSystemToUser: false,
        errorDeletePosSystemToUser: null,
      };
    case DELETE_POS_SYSTEM_TO_USER_SUCCESS:
      return {
        ...state,
        loadingDeletePosSystemToUser: false,
        successDeletePosSystemToUser: true,
      };
    case DELETE_POS_SYSTEM_TO_USER_FAILURE:
      return {
        ...state,
        loadingDeletePosSystemToUser: false,
        successDeletePosSystemToUser: false,
        errorDeletePosSystemToUser: action.payload,
      };
    case CREATE_POS_ORDER_PAYMENT_REQUEST:
      return {
        ...state,
        loadingCreatePosOrderPaymentRequest: true,
      };
    case CREATE_POS_ORDER_PAYMENT_REQUEST_SUCCESS:
      return {
        ...state,
        loadingCreatePosOrderPaymentRequest: false,
        successCreatePosOrderPaymentRequest: action.payload,
      };
    case CREATE_POS_ORDER_PAYMENT_REQUEST_FAILURE:
      return {
        ...state,
        loadingCreatePosOrderPaymentRequest: false,
        successCreatePosOrderPaymentRequest: action.payload,
        errorCreatePosOrderPaymentRequest: action.payload,
      };
    case CREATE_POS_ORDER_TENDER:
      return {
        ...state,
        loadingCreatePosOrderTender: true,
      };
    case CREATE_POS_ORDER_TENDER_SUCCESS:
      return {
        ...state,
        loadingCreatePosOrderTender: false,
        successCreatePosOrderTender: action.payload,
      };
    case CREATE_POS_ORDER_TENDER_FAILURE:
      return {
        ...state,
        loadingCreatePosOrderTender: false,
        successCreatePosOrderTender: action.payload,
        errorCreatePosOrderTender: action.payload,
      };
    case INTERNAL_TERMINAL_PAYMENT_RESULT:
      return {
        ...state,
        loadingInternalTerminalPaymentResult: true,
      };
    case INTERNAL_TERMINAL_PAYMENT_RESULT_SUCCESS:
      return {
        ...state,
        loadingInternalTerminalPaymentResult: false,
        successInternalTerminalPaymentResult: action.payload,
      };
    case INTERNAL_TERMINAL_PAYMENT_RESULT_FAILURE:
      return {
        ...state,
        loadingInternalTerminalPaymentResult: false,
        successInternalTerminalPaymentResult: action.payload,
        errorInternalTerminalPaymentResult: action.payload,
      };
      case INTERNAL_POS_SYSTEM_TICKETS_UPDATE:
      return {
        ...state,
        loadingInternalPosSystemTicketsUpdate: true,
      };
    case INTERNAL_POS_SYSTEM_TICKETS_UPDATE_SUCCESS:
      return {
        ...state,
        loadingInternalPosSystemTicketsUpdate: false,
        successInternalPosSystemTicketsUpdate: action.payload,
      };
    case INTERNAL_POS_SYSTEM_TICKETS_UPDATE_FAILURE:
      return {
        ...state,
        loadingInternalPosSystemTicketsUpdate: false,
        successInternalPosSystemTicketsUpdate: action.payload,
        errorInternalPosSystemTicketsUpdate: action.payload,
      };
      case GET_POS_SYSTEM_OVERVIEW:
        return {
          ...state,
          loadingPosSystemOverview: true,
        };
      case GET_POS_SYSTEM_OVERVIEW_SUCCESS:
        return {
          ...state,
          loadingPosSystemOverview: false,
          posSystemOverview: action.payload,
        };
      case GET_POS_SYSTEM_OVERVIEW_FAILURE:
        return {
          ...state,
          loadingPosSystemOverview: false,
          errorPosSystemOverview: action.payload,
        };
      case VOID_POS_ORDER_PAYMENT_REQUEST:
        return {
          ...state,
          loadingVoidPosOrderPaymentRequest: true,

        };
      case VOID_POS_ORDER_PAYMENT_REQUEST_SUCCESS:
        return {
          ...state,
          loadingVoidPosOrderPaymentRequest: false,
          successVoidPosOrderPaymentRequest: action.payload,
        };
      case VOID_POS_ORDER_PAYMENT_REQUEST_FAILURE:
        return {
          ...state,
          loadingVoidPosOrderPaymentRequest: false,
          successVoidPosOrderPaymentRequest: action.payload,
          errorVoidPosOrderPaymentRequest: action.payload,
        };
        case PRINT_POS_ORDER_RECEIPT:
          return {
            ...state,
            loadingPrintPosOrderReceipt: true,
          };
        case PRINT_POS_ORDER_RECEIPT_SUCCESS:
          return {
            ...state,
            loadingPrintPosOrderReceipt: false,
            successPrintPosOrderReceipt: action.payload,
          };
        case PRINT_POS_ORDER_RECEIPT_FAILURE:
          return {
            ...state,
            loadingPrintPosOrderReceipt: false,
            successPrintPosOrderReceipt: action.payload,
            errorPrintPosOrderReceipt: action.payload,
          };
          case EMAIL_POS_ORDER_RECEIPT:
            return {
              ...state,
              loadingEmailPosOrderReceipt: true,
            };
          case EMAIL_POS_ORDER_RECEIPT_SUCCESS:
            return {
              ...state,
              loadingEmailPosOrderReceipt: false,
              successEmailPosOrderReceipt: action.payload,
            };
          case EMAIL_POS_ORDER_RECEIPT_FAILURE:
            return {
              ...state,
              loadingEmailPosOrderReceipt: false,
              successEmailPosOrderReceipt: action.payload,
              errorEmailPosOrderReceipt: action.payload,
            };
              case REFUND_POS_ORDER:
        return {
          ...state,
          loadingRefundPosOrder: true,
        };
      case REFUND_POS_ORDER_SUCCESS:
        return {
          ...state,
          loadingRefundPosOrder: false,
          successRefundPosOrder: action.payload,
        };
      case REFUND_POS_ORDER_FAILURE:
        return {
          ...state,
          loadingRefundPosOrder: false,
          successRefundPosOrder: action.payload,
          errorRefundPosOrder: action.payload,
        };

    default:
      return state;
  }
};

export default posSystemReducer;
